import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import Consulting1 from "Assets/Common/Consulting/gestao-de-recursos-1.jpeg";
import Consulting2 from "Assets/Common/Consulting/gestao-de-recursos-2.jpeg";
import Productions2 from "Assets/Common/Productions/12-anos.jpeg";
import Productions3 from "Assets/Common/Productions/foto-as-brasas.jpeg";
import Productions4 from "Assets/Common/Productions/foto-baile-partincundum.jpeg";
import Productions5 from "Assets/Common/Productions/foto-cock-briga-de-galo.jpeg";
import Productions6 from "Assets/Common/Productions/foto-dogville.jpeg";
import Productions7 from "Assets/Common/Productions/foto-ficcoes.jpeg";
import Productions8 from "Assets/Common/Productions/foto-fim-de-caso.jpeg";
import Productions9 from "Assets/Common/Productions/foto-fonchito-e-a-lua.jpeg";
import Productions10 from "Assets/Common/Productions/foto-la-dentro-tem-coisa.jpeg";
import Productions1 from "Assets/Common/Productions/foto-mas-porque.jpeg";
import Productions11 from "Assets/Common/Productions/foto-memorias-de-adriano.jpeg";
import Productions12 from "Assets/Common/Productions/foto-rj-de-shakespeare.jpeg";
import Productions13 from "Assets/Common/Productions/kafka.jpg";
import Resources1 from "Assets/Common/Resources/alicerce-2.jpg";
import Resources2 from "Assets/Common/Resources/cades.jpg";
import Resources3 from "Assets/Common/Resources/conexao-do-bem.jpg";
import Resources4 from "Assets/Common/Resources/escola-de-musica-da-rocinha.jpg";
import Resources6 from "Assets/Common/Resources/festival-de-jazz-de-trancoso-2.jpg";
import Resources7 from "Assets/Common/Resources/festival-de-jazz-de-trancoso.jpg";
import Resources8 from "Assets/Common/Resources/futsertao.jpeg";
import Resources9 from "Assets/Common/Resources/graac-2.jpg";
import Resources13 from "Assets/Common/Resources/julita-1.jpg";
import Resources14 from "Assets/Common/Resources/julita-3.jpg";
import Resources10 from "Assets/Common/Resources/mano-down.png";
import Resources11 from "Assets/Common/Resources/norte-marketing-2.jpeg";
import Resources12 from "Assets/Common/Resources/orquestra-mare-do-amanha.jpg";
import Resources from "Assets/Common/caixa-captacao-de-recursos.png";
import Consulting from "Assets/Common/consulting-image-home.png";
import Brasas from "Assets/Common/foto-as-brasas.jpeg";
import Cock from "Assets/Common/foto-cock-briga-de-galo.jpeg";
import Dogville from "Assets/Common/foto-dogville.jpeg";
import Ficcoes from "Assets/Common/foto-ficcoes.jpeg";
import Caso from "Assets/Common/foto-fim-de-caso.jpeg";
import Kafka from "Assets/Common/kafka.jpg";
import Logo from "Assets/Common/logo.png";
import ArtisticProductions from "Assets/Common/resources.png";

import AuthRoutes from "Routes/Components/Auth";
import NoAuthRoutes from "Routes/Components/NoAuth";

import { peekPostLoginRedirect } from "Helpers/PostLoginRedirect";

import UseAuth from "Hooks/UseAuth";

import Button from "Components/Global/Buttons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const Dashboard = () => {
  const { authorized } = UseAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const intervalRef = useRef();

  const [selected, setSelected] = useState("resources"); // resources, consulting, artistic
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentResourceIndex, setCurrentResourceIndex] = useState(0);
  const [currentConsultingIndex, setCurrentConsultingIndex] = useState(0);
  const [currentProductionIndex, setCurrentProductionIndex] = useState(0);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Chegou na home apenas porque precisava de sessão para abrir um link direto
  // (ex.: link de interesse do e-mail do patrocinador): já abre o login, para o
  // usuário não ter que descobrir onde ele fica.
  useEffect(() => {
    if (!authorized && peekPostLoginRedirect())
      window.dispatchEvent(new Event("open-auth-modal"));
  }, [authorized]);

  const mainContent = {
    resources: {
      title: "Captação de Recursos",
      description:
        "Área designada para proponentes interessados em uma parceria para a captação de recursos. <br /> Através de uma análise detalhada dos projetos recebidos e das oportunidades de mercado, conectamos proponentes com projetos aptos a captar à incentivadores interessados em investir no setor cultural, esportivo e social.",
      src: "",
      buttonText: "Envie seu projeto",
      variant: "primary",
      path: AuthRoutes.CreateProject.path,
    },
    consulting: {
      title: "Consultoria e Gestão de Recursos Incentivados",
      description:
        "Área designada para empresas que desejam começar a utilizar recursos incentivados ou otimizar o processo de utilização desses recursos em prol de projetos culturais, esportivos e sociais. <br /> Após analisar o potencial de investimento da empresa nas leis de incentivo fiscal, em parceria com o departamento tributário, e de dialogar com as áreas de responsabilidade social e de marketing, a Sevenx consegue mapear oportunidades e auxiliar empresas de todo o País a otimizarem o aproveitamento dos seus tributos em prol dos projetos que mais dialoguem com o seu propósito.",
      src: Consulting,
      buttons: [
        {
          label: "Entre em contato",
          variant: "tertiary",
          path: "/consulting-and-management#contact",
        },
        {
          label: "Saiba mais",
          variant: "",
          path: "/consulting-and-management#know-more",
        },
      ],
    },
    artistic: {
      title: "Sevenx Produções Artísticas",
      description:
        "Empreender através da idealização de projetos culturais, esportivos e sociais de impacto e relevância, é a nossa missão. <br /> Desde que iniciou sua atividades, a Sevenx Produções Artísticas vem se especializando na idealização e execução de projetos culturais, esportivos e sociais na expectativa de contribuir, através deles, para uma sociedade mais diversa, igualitária e inclusiva.",
      src: ArtisticProductions,
      buttonText: "Conheça nossos projetos",
      variant: "secondary",
      path: "/productions",
    },
  };

  useEffect(() => {
    // create a loop that changes the selected state every 20 seconds
    const interval = setInterval(() => {
      setSelected((prev) => {
        if (prev === "resources") return "consulting";
        if (prev === "consulting") return "artistic";
        return "resources";
      });
    }, 10000);

    intervalRef.current = interval;

    return () => clearInterval(interval.current);
  }, []);

  const changeSelected = (name) => {
    setSelected(name);
    clearInterval(intervalRef.current);
  };

  const mainImages = [
    {
      id: 1,
      src: Brasas,
      alt: "As Brasas",
    },
    {
      id: 2,
      src: Cock,
      alt: "Cock - Briga de Galo",
    },
    {
      id: 3,
      src: Dogville,
      alt: "Dogville",
    },
    {
      id: 4,
      src: Ficcoes,
      alt: "Ficções",
    },
    {
      id: 5,
      src: Caso,
      alt: "Fim de Caso",
    },
    {
      id: 6,
      src: Kafka,
      alt: "Kafka",
    },
  ];

  const resources = [
    {
      id: 1,
      src: Resources1,
    },
    {
      id: 2,
      src: Resources2,
    },
    {
      id: 3,
      src: Resources3,
    },
    {
      id: 4,
      src: Resources4,
    },
    {
      id: 6,
      src: Resources6,
    },
    {
      id: 7,
      src: Resources7,
    },
    {
      id: 8,
      src: Resources8,
    },
    {
      id: 9,
      src: Resources9,
    },
    {
      id: 10,
      src: Resources10,
    },
    {
      id: 11,
      src: Resources11,
    },
    {
      id: 12,
      src: Resources12,
    },
    {
      id: 13,
      src: Resources13,
    },
    {
      id: 14,
      src: Resources14,
    },
  ];

  const consulting = [
    {
      id: 1,
      src: Consulting1,
    },
    {
      id: 2,
      src: Consulting2,
    },
  ];

  const productions = [
    {
      id: 1,
      src: Productions1,
    },
    {
      id: 2,
      src: Productions2,
    },
    {
      id: 3,
      src: Productions3,
    },
    {
      id: 4,
      src: Productions4,
    },
    {
      id: 5,
      src: Productions5,
    },
    {
      id: 6,
      src: Productions6,
    },
    {
      id: 7,
      src: Productions7,
    },
    {
      id: 8,
      src: Productions8,
    },
    {
      id: 9,
      src: Productions9,
    },
    {
      id: 10,
      src: Productions10,
    },
    {
      id: 11,
      src: Productions11,
    },
    {
      id: 12,
      src: Productions12,
    },
    {
      id: 13,
      src: Productions13,
    },
  ];

  // Autoplay para o carousel de banner
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === mainImages.length - 1 ? 0 : prevIndex + 1,
      );
    }, 5000); // Troca a cada 5 segundos

    return () => clearInterval(interval);
  }, [mainImages.length]);

  // Autoplay para Resources carousel
  useEffect(() => {
    if (selected === "resources") {
      const interval = setInterval(() => {
        setCurrentResourceIndex((prevIndex) =>
          prevIndex === resources.length - 1 ? 0 : prevIndex + 1,
        );
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [selected, resources.length]);

  // Autoplay para Consulting carousel
  useEffect(() => {
    if (selected === "consulting") {
      const interval = setInterval(() => {
        setCurrentConsultingIndex((prevIndex) =>
          prevIndex === consulting.length - 1 ? 0 : prevIndex + 1,
        );
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [selected, consulting.length]);

  // Autoplay para Productions carousel
  useEffect(() => {
    if (selected === "artistic") {
      const interval = setInterval(() => {
        setCurrentProductionIndex((prevIndex) =>
          prevIndex === productions.length - 1 ? 0 : prevIndex + 1,
        );
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [selected, productions.length]);

  return (
    <S.Container>
      {showLoginModal && (
        <S.ModalOverlay onClick={() => setShowLoginModal(false)}>
          <S.ModalContent onClick={(e) => e.stopPropagation()}>
            <S.ModalClose onClick={() => setShowLoginModal(false)}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </S.ModalClose>

            <S.ModalHeader>
              <h3>Crie sua conta ou faça login</h3>
              <p>
                Para enviar seu projeto e ter acesso a todas as funcionalidades
                da plataforma, você precisa estar autenticado.
              </p>
            </S.ModalHeader>

            <S.ModalButtons>
              <Button
                variant="primary"
                text="Criar conta"
                width="100%"
                onClick={() => {
                  setShowLoginModal(false);
                  navigate(AuthRoutes.Register.path);
                }}
              />
              <Button
                variant="secondary"
                text="Já tenho conta"
                width="100%"
                onClick={() => {
                  setShowLoginModal(false);
                  window.dispatchEvent(new Event("open-auth-modal"));
                }}
              />
            </S.ModalButtons>
            <S.ModalForgotPassword
              onClick={() => {
                setShowLoginModal(false);
                navigate(NoAuthRoutes.ForgotPassword.path);
              }}
            >
              Esqueci minha senha
            </S.ModalForgotPassword>
          </S.ModalContent>
        </S.ModalOverlay>
      )}

      <S.Banner>
        <S.CarouselContainer>
          {mainImages.map((image, index) => (
            <S.BannerImg
              key={image.id}
              src={image.src}
              alt={image.alt}
              $active={index === currentImageIndex}
            />
          ))}
        </S.CarouselContainer>
        <S.Logo src={Logo} alt="Logo Sevenx" />

        <S.Boxes>
          <S.Box
            color={theme.colors.primary.blue}
            onClick={() => changeSelected("resources")}
          >
            <S.BoxBg
              color={theme.colors.primary.blue}
              $active={selected === "resources"}
            />
            <img src={Resources} alt="Resources" />
            <span>Captação de Recursos</span>
          </S.Box>

          <S.Box
            color={theme.colors.primary.orange}
            onClick={() => changeSelected("consulting")}
          >
            <S.BoxBg
              color={theme.colors.primary.orange}
              $active={selected === "consulting"}
            />
            <img src={Consulting} alt="Consulting" />
            <span>Consultoria e Gestão de Recursos Incentivados</span>
          </S.Box>

          <S.Box
            color={theme.colors.primary.green}
            onClick={() => changeSelected("artistic")}
          >
            <S.BoxBg
              color={theme.colors.primary.green}
              $active={selected === "artistic"}
            />
            <img src={ArtisticProductions} alt="ArtisticProductions" />
            <span>Produções Artísticas</span>
          </S.Box>
        </S.Boxes>
      </S.Banner>

      <S.Main>
        <S.MainContent>
          <S.Column>
            <h2>{mainContent[selected].title}</h2>

            {mainContent[selected].description
              .split("<br />")
              .map((text, index) => (
                <p key={index}>
                  {text}
                  <br />
                </p>
              ))}

            {mainContent[selected].buttons && (
              <S.ButtonsWrapper>
                {mainContent[selected].buttons.map((button, index) => (
                  <HashLink key={index} to={button.path}>
                    <Button variant={button.variant} text={button.label} />
                  </HashLink>
                ))}
              </S.ButtonsWrapper>
            )}

            {!mainContent[selected].buttons && (
              <Button
                variant={mainContent[selected].variant}
                onClick={() => {
                  if (selected === "resources" && !authorized) {
                    setShowLoginModal(true);
                    return;
                  }

                  navigate(mainContent[selected].path);
                }}
                text={mainContent[selected].buttonText}
              />
            )}
          </S.Column>
          {mainContent[selected].title === "Captação de Recursos" && (
            <S.CarouselWrapper>
              {resources.map((resource, index) => (
                <S.CarouselImage
                  key={resource.id}
                  src={resource.src}
                  alt={`Resource ${index}`}
                  $active={index === currentResourceIndex}
                />
              ))}
            </S.CarouselWrapper>
          )}
          {mainContent[selected].title ===
            "Consultoria e Gestão de Recursos Incentivados" && (
            <S.CarouselWrapper>
              {consulting.map((consultingItem, index) => (
                <S.CarouselImage
                  key={consultingItem.id}
                  src={consultingItem.src}
                  alt={`Consulting ${index}`}
                  $active={index === currentConsultingIndex}
                />
              ))}
            </S.CarouselWrapper>
          )}
          {mainContent[selected].title === "Sevenx Produções Artísticas" && (
            <S.CarouselWrapper>
              {productions.map((production, index) => (
                <S.CarouselImage
                  key={production.id}
                  src={production.src}
                  alt={`Production ${index}`}
                  $active={index === currentProductionIndex}
                />
              ))}
            </S.CarouselWrapper>
          )}
        </S.MainContent>
      </S.Main>
    </S.Container>
  );
};

export default Dashboard;
